import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

// Css
import classes from "./testEventCard.module.css";

// Img
import calendar from "../../../assets/png/calendar.png";
import icCalendarRound from "../../../assets/svg/ic-calendar-grey-round.svg";
import icClockRound from "../../../assets/svg/ic-clock-grey-round.svg";
import icTeamRound from "../../../assets/svg/ic-team-grey-round.svg";
import icLocationRound from "../../../assets/svg/ic-location-grey-round.svg";

// Jds
import { BadgeV2, Button, Container, Icon, Tooltip } from "@jds/core";

// Local
import { baseToImg } from "../../../util/helper";
import decryptUrl from "../../../util/img-decryption";
import RescheduleEventForm from "../Form/RescheduleEventForm";
import JdsModal from "../JdsModal";
import SuccessModal from "../SuccessModal/SuccessModal";
import { useDispatch } from "react-redux";
import { eventListTrigger } from "../../../store/state-slices/apiTrigger";
import CardOverlay from "./CardOverlay";
import { Stack } from "@mui/material";

const TestEventCard = (props) => {
  const { data } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isEditModalClose, setEditModalClose] = useState(true);
  const [successModal, setSuccessModal] = useState(true);
  const [apiSuccess, setApiSuccess] = useState(false);
  useEffect(() => {
    if (apiSuccess) {
      dispatch(eventListTrigger());
    }
  }, [apiSuccess]);
  return (
    <div className={`${classes.card}`}>
      {/* <img alt="" src={data.bannerimage ? baseToImg(data.bannerimage) : ""} /> */}
      <div
        className={classes["banner-container"]}
        style={{ position: "relative", overflow: "hidden" }}
      >
        <img
          alt=""
          src={data.bannerimage ? decryptUrl(data.bannerimage) : ""}
        />
        <CardOverlay style={{ borderRadius: "24px" }} />
      </div>
      <span>
        <img
          alt=""
          // src={data.eventTypeIcon ? baseToImg(data.eventTypeIcon) : ""}
          src={data.eventTypeIcon ? decryptUrl(data.eventTypeIcon) : ""}
        />

        {data.eventTypeName}
      </span>
      {data?.isAutoApproval && (
        <div className={classes["public-label"]}>
          <BadgeV2 label="Public" informationKind="label" size="xtra-large" />
        </div>
      )}
      <Stack direction="column" justifyContent="space-between" flex={1}>
        <div className={classes.details}>
          <h6>{data.name}</h6>
          <div>
            <img alt="" src={icCalendarRound} />
            <p>
              {data.startDate} {data.startDate !== data.endDate && `(From)`}
            </p>
          </div>

          {data.startDate === data.endDate ? (
            <div>
              <img alt="" src={icClockRound} />
              <p>{data.time}</p>
            </div>
          ) : (
            <div>
              <img alt="" src={icCalendarRound} />
              <p>{data.endDate} (To)</p>
            </div>
          )}
          <div>
            <img alt="" src={icTeamRound} />

            <p>{data.attendeeCount} Guest</p>
          </div>
          <div>
            <img alt="" src={icLocationRound} />
            <Tooltip label={data.locationName} position="bottom">
              <p>{data.locationName}</p>
            </Tooltip>
          </div>

          {/* Reschedule form Modal */}
          <JdsModal
            header="Reschedule Event"
            size="m"
            close={isEditModalClose}
            onClose={() => {
              setEditModalClose(true);
            }}
          >
            {!isEditModalClose && (
              <RescheduleEventForm
                eventDetails={data}
                setSuccessModal={() => {
                  setSuccessModal(false);
                }}
              />
            )}
          </JdsModal>
          {!successModal && (
            <SuccessModal
              close={successModal}
              onClose={() => {
                setSuccessModal(true);
                setApiSuccess(true);
              }}
              subtitle="Your event has been rescheduled successfully."
              btnAction={() => {
                setSuccessModal(true);
                // setApiSuccess(true);
                navigate(`/home/events/event-detail/${data?.id}`);
              }}
              btnText="Go to Event"
            />
          )}
        </div>

        <Container
          fullWidth
          horizontalAlign="space-between"
          verticalAlign="center"
          style={{ paddingInline: "16px", marginTop: "16px" }}
        >
          {data.archive && data.cancelComment ? (
            <BadgeV2
              label={`Event Cancelled : ${data.cancelComment}`}
              color="negative"
              informationKind="label"
              size="small"
            />
          ) : (
            <Button
              kind="primary"
              label="more info"
              onClick={() => navigate(`/home/events/event-detail/${data.id}`)}
            />
          )}

          {data.archive && (
            <Icon
              ic={"IcCalendarWeek"}
              onClick={() => setEditModalClose(false)}
            />
          )}
        </Container>
      </Stack>
    </div>
  );
};

export default TestEventCard;
